module.exports = __webpack_public_path__ + "static/media/go-to.dc84bee6.svg";